/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsTriggerReprocessOlafReprocessMutationRequest, AuditReportsTriggerReprocessOlafReprocessMutationResponse, AuditReportsTriggerReprocessOlafReprocess401, AuditReportsTriggerReprocessOlafReprocess403 } from "../models/AuditReportsTriggerReprocessOlafReprocess";

export function getAuditReportsTriggerReprocessOlafReprocessUrl() {
  const res = { method: 'POST', url: `/audit-reports/v1/olaf/reprocess` as const }
  return res
}

/**
 * @summary Trigger standalone OLAF reprocess
 * {@link /audit-reports/v1/olaf/reprocess}
 */
export async function auditReportsTriggerReprocessOlafReprocess(data: AuditReportsTriggerReprocessOlafReprocessMutationRequest, config: Partial<RequestConfig<AuditReportsTriggerReprocessOlafReprocessMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsTriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessOlafReprocess401 | AuditReportsTriggerReprocessOlafReprocess403>, AuditReportsTriggerReprocessOlafReprocessMutationRequest>({ method : "POST", url : getAuditReportsTriggerReprocessOlafReprocessUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}